import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=4a710782&"
import script from "./pageLayout.vue?vue&type=script&lang=ts&"
export * from "./pageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports